import React from 'react';

import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { RootState } from '../../../types';
import { getLeoMediaUrl } from '../../../utils/ImageUtils';
import { MediaTypeEnum } from '../../../utils/LeoUtils';
import { ShareablesCarousel } from './ShareablesCarousel';
import NeoLeoGenericShareablesInfoSection from './NeoLeoGenericShareablesInfoSection';

type NeoLeoGenericShareableModalProps = {
  closeModal(): void;
};

const NeoLeoGenericShareableModal: React.FC<
  NeoLeoGenericShareableModalProps
> = ({ closeModal }) => {
  const { media, activeShareableIndex, msgId } = useSelector(
    (state: RootState) => ({
      activeShareableIndex: state.leo.shareables.activeShareableIndex!,
      msgId: state.leo.shareables.msgId,
      media: state.leo.msgContext?.media,
    }),
  );

  const shareables = media
    ?.filter((el) => !!el.media_url && el.type !== MediaTypeEnum.SHARRAN)
    .map((el) => ({
      ...el,
      media_url: getLeoMediaUrl(el.media_url)!,
    }));

  if (!shareables) {
    return null;
  }

  return (
    <div
      className='fixed top-0 bottom-0 left-0 right-0 z-50 w-full h-full-window'
      title='Leo Social Shareable Modal'
    >
      <div
        className='absolute top-0 bottom-0 left-0 right-0 z-0 block bg-black bg-opacity-60'
        role='button'
        onClick={(e) => {
          e.preventDefault();
          closeModal();
        }}
      />
      <div className='flex items-center justify-center w-full h-full p-4 lg:p-0'>
        <div
          className='absolute top-0 bottom-0 left-0 right-0 z-0 block bg-black bg-opacity-60'
          role='button'
          onClick={(e) => {
            e.preventDefault();
            closeModal();
          }}
        />
        <div className='flex items-center justify-center w-full h-full p-4 lg:p-0'>
          <div
            className={classNames(
              'max-h-[85%] rounded-xl z-[100] scrollbar overflow-y-auto w-full lg:w-11/12 xl:w-3/4',
            )}
            aria-label='simple-modal'
          >
            <ShareablesCarousel
              activeShareableIndex={activeShareableIndex}
              items={shareables.map((shareable) => (
                <div
                  key={shareable.media_url}
                  className='relative z-[100] flex flex-row rounded-xl overflow-hidden shadow-gemini-web h-[500px]'
                >
                  <div className='bg-reskin-grey-200 p-4 w-1/2'>
                    <img
                      id='poster-image'
                      src={shareable.media_url}
                      className=' border rounded-lg h-full w-full'
                      alt='poster'
                    />
                  </div>
                  <div className='w-1/2'>
                    <NeoLeoGenericShareablesInfoSection
                      msgId={msgId!}
                      shareablesInfo={shareable}
                    />
                  </div>
                  <div className='absolute top-2 right-2 bg-reskin-regent-400 w-6 h-6 rounded-full flex items-center justify-center'>
                    <FontAwesomeIcon
                      icon={faClose}
                      className='text-white bg-reskin-regent-400 cursor-pointer text-sm'
                      onClick={(e) => {
                        e.preventDefault();
                        closeModal();
                      }}
                    />
                  </div>
                </div>
              ))}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NeoLeoGenericShareableModal;
